import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  address: {
    street: '',
    city: '',
    stateProvince: '',
    postalCode: '',
    country: '',
  },
  type: 'Finance',
  logo: null,
};

const setupSlice = createSlice({
  name: 'setup',
  initialState,
  reducers: {
    updateFactoringCompany: (state, action) => {
      state.name = action.payload.name;
      state.address = action.payload.address;
      state.type = action.payload.type;
      state.logo = action.payload.logo;
    },
    updateAddress: (state, action) => {
      state.address = action.payload;
    },
  },
});

export const { updateFactoringCompany, updateAddress } = setupSlice.actions;

export default setupSlice.reducer;
